import React, { FunctionComponent, PropsWithChildren } from 'react';

import { default as MuiTab, TabProps } from '@mui/material/Tab';

const Tab: FunctionComponent<TabProps<React.ElementType>> = (
  props: PropsWithChildren<TabProps<React.ElementType>>
): JSX.Element => {
  return <MuiTab {...props}>{props.children}</MuiTab>;
};

export default Tab;
